/*
 * Copyright (c) Nexign, JSC, 2023-2024.
 */
/**
 *
 *
 * @author Dmitry Pavlov
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.23.0
 */

export type TRoundTypes = 'floor' | 'round' | 'ceil';

const decimalAdjust = (type: TRoundTypes, value: number, exp?: number) => {
    // Если степень не определена, либо равна нулю...
    if (!exp) {
        return Math[type](value);
    }

    // Если значение не является числом, либо степень не является целым числом...
    if (Number.isNaN(value) || exp % 1 !== 0) {
        return undefined;
    }

    // Сдвиг разрядов
    const splittedValue = value.toExponential().split('e');
    const shiftValue = Math[type](+(splittedValue[0] + 'e' + (splittedValue[1] ? +splittedValue[1] - exp : -exp)));

    // Обратный сдвиг
    const splttedShiftValue = shiftValue.toExponential().split('e');
    const unshiftValue = +(splttedShiftValue[0] + 'e' + (splttedShiftValue[1] ? +splttedShiftValue[1] + exp : exp));

    return unshiftValue;
};

// Округление к ближайшему
export const round10 = (value: number, exp?: number) => decimalAdjust('round', value, exp);
// Округление вниз
export const floor10 = (value: number, exp?: number) => decimalAdjust('floor', value, exp);
// Округление вверх
export const ceil10 = (value: number, exp?: number) => decimalAdjust('ceil', value, exp);
